









































































































import Vue from 'vue';

import {Component, Prop, Watch} from "vue-property-decorator";

import Axios from "axios";
import Modal from "./Modal.vue";
import {ICrsConverter} from "./ICrsConverter";
import ModeIcon from "./ModeIcon.vue";
import {FetchError} from "./RefundView.vue";
import {IJourneyDetails, LegRecord} from "./JourneyDetails";
import {IDryRunResponse, IRefundStatusJourney, IRefundStatusResponse} from "./IRefundStatusJourney";
import {LookupJourneyResponseItem} from "./lookup-journeys";
import {DateTime} from "luxon";

class ConfirmRefundReplacementRequest {
    public replacementBookingReference: string;
    public replacementJourneyId: string;
    public protectedReference: string;
    public journeyId: string;


    constructor(protectedReference: string, journeyId: string, replacementBookingReference: string, replacementJourneyId: string) {
        this.replacementBookingReference = replacementBookingReference;
        this.replacementJourneyId = replacementJourneyId;
        this.protectedReference = protectedReference;
        this.journeyId = journeyId;
    }
}

@Component({
    components: {
        ModeIcon,
        Modal
    }
})
export default class JourneyPickerModal extends Vue {
    @Prop() retrievedJourneys: Array<LookupJourneyResponseItem>;
    @Prop() refundStatus: IRefundStatusJourney;
    @Prop() crsConverter: ICrsConverter;
    @Prop() currencyFormatter: Intl.NumberFormat;
    @Prop() details: IJourneyDetails;
    @Prop() protectedReference: string;
    @Prop() replacementStatusResponse: IRefundStatusResponse;


    selectedIndex: Number = 0;

    loading: boolean = false;
    errorFetchingData: FetchError = null;
    dryRunResult: IDryRunResponse = null;
    dryRunError: string = null;

    mounted() {
        this.doDryRunFor(this.selectedIndex);
    }

    getDate(dt: string): string {
        const luxonDate = DateTime.fromISO(dt);
        return luxonDate.toFormat('dd/MM/yyyy');
    }

    changeText(legRecords: Array<LegRecord>) {
        if (legRecords.length === 1) {
            return "direct service";
        }
        const plural = legRecords.length === 2 ? "" : "s";
        return (legRecords.length - 1) + " change" + plural;
    }

    getTime(dt: string): string {
        const luxonObject = DateTime.fromISO(dt);
        return luxonObject.toFormat('HH:mm');
    }

    get refundAmount(): number {
        const journey = this.retrievedJourneys[this.selectedIndex];
        const replacementJourney = this.replacementStatusResponse.journeys.filter(j => j.journeyID === journey.journeyID)[0];
        const valueOfReplacementJourney = replacementJourney.ticketsValueAsReplacement;
        const valueOfOriginalBooking = this.refundStatus.ticketsReplaceValue;
        if (valueOfReplacementJourney < valueOfOriginalBooking) {
            return valueOfReplacementJourney - this.refundStatus.adminFeeReplacement;
        }
        return valueOfOriginalBooking - this.refundStatus.adminFeeReplacement;
    }

    get refundPermitted(): boolean {
        const journey = this.retrievedJourneys[this.selectedIndex];

        return true;
    }

    @Watch("selectedIndex")
    onSelectedJourneyChange(value: number, old: number) {
        this.doDryRunFor(value);
    }

    doDryRunFor(index: number): void {
        this.$insProgress.start();
        Axios.post<ConfirmRefundReplacementRequest, IDryRunResponse>(
            "/api/ProcessRefundWithReplacement/DryRun",
            new ConfirmRefundReplacementRequest(
                this.protectedReference,
                this.refundStatus.journeyID,
                this.retrievedJourneys[index].bookingReference,
                this.retrievedJourneys[index].journeyID
            )
        ).then(
            (response) => {
                this.dryRunResult = response.data as IDryRunResponse;
                this.dryRunError = null;
                this.$insProgress.finish();
            }).catch((error) => {
                this.dryRunResult = null;
                if (error.response !== null) {
                    this.dryRunError = error.response.data;
                } else {
                    this.errorFetchingData = new FetchError(error, null);
                }
                this.$insProgress.finish();
            }
        );
    }

    processReplacementRefund(): void {
        if (this.dryRunError) {
            return;
        }
        const journey = this.retrievedJourneys[this.selectedIndex];
        this.$insProgress.start();
        this.loading = true;
        Axios.post<ConfirmRefundReplacementRequest, Object>(
            "/api/ProcessRefundWithReplacement",
            new ConfirmRefundReplacementRequest(
                this.protectedReference,
                this.refundStatus.journeyID,
                journey.bookingReference,
                journey.journeyID
            )
        ).then(
            (response) => {
                console.log("received response", response.data);
                this.$emit("finished");
                this.$insProgress.finish();
            }).catch((error) => {
                if (error.response !== null) {
                    this.errorFetchingData = new FetchError(error.toString(), error.response.data);
                } else {
                    this.errorFetchingData = new FetchError(error, null);
                }
                this.$insProgress.finish();
                this.loading = false;
            }
        );
    }
}

